import type { Component } from 'vue';

import { AlertTriangle, Check, Info, Xcircle } from '@celerdata/icons';

// Single source of truth for "what icon does a notice msg_type render as".
// Shared by AppBanner (top banner flashbar) and the sidebar notification
// dropdown so the type→icon mapping doesn't drift across two surfaces.

export type NoticeType = 'info' | 'success' | 'warning' | 'error';

const NOTICE_ICON: Record<NoticeType, Component> = {
  info: Info,
  success: Check,
  warning: AlertTriangle,
  error: Xcircle,
};

export function getNoticeIcon(type: string | undefined): Component {
  return NOTICE_ICON[(type as NoticeType) || 'info'] ?? Info;
}

// msg_priority → priority bucket. The list is kept in numeric order matching
// backend codes.
const PRIORITY_TO_TYPE: NoticeType[] = ['error', 'info', 'success', 'warning', 'error'];

export function priorityToType(msgPriority: number | undefined): NoticeType {
  if (msgPriority === undefined || msgPriority < 0 || msgPriority >= PRIORITY_TO_TYPE.length) {
    return 'info';
  }
  return PRIORITY_TO_TYPE[msgPriority]!;
}
